import { NgModule } from '@angular/core';
import { CheckoutComponent } from "./checkout.component";
import { CheckoutDisplayComponent } from "./checkout-display/checkout-display.component"
import { CheckoutDisplayPresentation } from "./checkout-display/checkout-display.presentation"
import { TicketAddressComponent } from "./ticket-address/ticket-address.component"
import { TicketAddressForm } from "./ticket-address/ticket-address-form/ticket-address-form.component"
import { CheckoutAddressDisplayPresentation } from "./checkout-address-display/checkout-address-display.presentation"
import { CheckoutCustomerDisplayPresentation } from "./checkout-customer-display/checkout-customer-display.presentation"
import { CompletePaymentComponent } from './complete-payment/complete-payment.component';
import { CompletePaymentPresentation } from './complete-payment/complete-payment.presentation';

import { ValidationService } from '../../services';
import { UiHelperModule } from "../../ui-helper";
import { ShoppingcartModule } from "../shopping-cart";
import { EffectsModule } from "@ngrx/effects"
import { CheckoutEffect } from "./checkout.effect"
import { DocumentModule } from "../documents/document.module"

import { CheckoutResolver } from "./checkout.resolver";

@NgModule({
	imports: [
		UiHelperModule,
		ShoppingcartModule,
		DocumentModule,
		EffectsModule.forFeature([CheckoutEffect])
	],
	declarations: [
		CheckoutComponent,
		CheckoutDisplayComponent,
		CheckoutDisplayPresentation,
		TicketAddressComponent,
		TicketAddressForm,
		CheckoutCustomerDisplayPresentation,
		CheckoutAddressDisplayPresentation,
		CompletePaymentComponent,
		CompletePaymentPresentation
	],
	exports: [
		TicketAddressComponent
	],
	providers: [
		ValidationService,
		CheckoutResolver
	]
})
export class CheckoutComponentsModule {
	static forRoot() {
		return {
			ngModule: CheckoutComponentsModule
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/checkout-components.module.ts